module.exports = __webpack_public_path__ + "static/slack-event-webhook-bd8254f23160720e59c384c91131766f.png";